import { useQuery } from "@tanstack/react-query";
import {
  GetLifecycleEventLineItemsResponse,
  GetLifecycleEventLineItemsSearchRequest,
  LifecycleManagementClient,
} from "@lib/ShiOneClient";
import { ApiClientConfig } from "../../../../../../../auth/ApiClientConfig";
import { ASSET_LIFECYCLE_QUERY_KEYS } from "../constants";

export function useGetAssetLifecycleManagementDrawerLineItemsData(
  request: GetLifecycleEventLineItemsSearchRequest,
) {
  const hasIdentifiers = (request.uniqueIdentifiers?.length ?? 0) > 0;

  function fetchAssetLifecycleData(): Promise<GetLifecycleEventLineItemsResponse> {
    const api = new LifecycleManagementClient(
      ApiClientConfig,
      import.meta.env.API_ENDPOINT,
    );
    return api.getEventLineItems(request);
  }

  return useQuery({
    queryKey: [ASSET_LIFECYCLE_QUERY_KEYS.drawerLineItems, request],
    queryFn: async () => {
      return await fetchAssetLifecycleData();
    },
    staleTime: 5 * 60 * 1000, // 5 minutes
    enabled: hasIdentifiers,
  });
}
